import { FieldInputType, NodeType, RowType } from '@getaccept/editor-lib/src/types/enums';

export interface ContentItem {
  icon: string;
  title: string;
  description: string;
  type?: NodeType | RowType | FieldInputType;
  parentType?: NodeType;
  contentId?: string;
  isNew?: boolean;
}

export const contentElements: ContentItem[] = [
  {
    icon: 'text',
    title: 'text',
    description: 'text-element-description',
    type: NodeType.Text,
  },
  {
    icon: 'image',
    title: 'image',
    description: 'image-element-description',
    type: NodeType.Image,
  },
  {
    icon: 'document-play',
    title: 'video',
    description: 'video-element-description',
    type: NodeType.Video,
  },
  {
    icon: 'coins',
    title: 'pricing-table',
    description: 'pricing-table-element-description',
    type: NodeType.PricingTable,
  },
  {
    icon: 'table',
    title: 'table',
    description: 'table-element-description',
    type: NodeType.Table,
  },
  {
    icon: 'text-divider',
    title: 'divider',
    description: 'divider-element-description',
    type: NodeType.Divider,
  },
];

export const layoutElements: ContentItem[] = [
  {
    icon: 'columns',
    title: 'columns-layout',
    description: 'columns-layout-description',
    type: RowType.Columns,
  },
  {
    icon: 'column-sidebyside',
    title: 'image-and-text',
    description: 'image-and-text-description',
    type: RowType.SideBySide,
  },
];

export const engagementElements: ContentItem[] = [
  {
    icon: 'link',
    title: 'link',
    description: 'link-element-description',
    type: NodeType.Link,
  },
  {
    icon: 'form',
    title: 'text-input',
    description: 'form-text-input-description',
    type: FieldInputType.Text,
    parentType: NodeType.Form,
  },
  {
    icon: 'dropdown',
    title: 'dropdown',
    description: 'form-dropdown-input-description',
    type: FieldInputType.Dropdown,
    parentType: NodeType.Form,
  },
  {
    icon: 'checkbox',
    title: 'checkbox',
    description: 'form-checkbox-input-description',
    type: FieldInputType.Checkbox,
    parentType: NodeType.Form,
  },
  {
    icon: 'signature',
    title: 'signature',
    isNew: true,
    description: 'signature_element_description',
    type: NodeType.Signature,
  },
];

export const uploadElements: ContentItem[] = [
  {
    icon: 'presentation',
    title: 'slideshow',
    description: 'slideshow_element_description',
    type: RowType.SlideShow,
  },
];
